import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import OktaConfiguration from './auth/OktaConfiguration';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import reportWebVitals from './reportWebVitals';
import { loadConfig } from './config/runtimeConfig';

// Load runtime config (from /config/config.json written by configure.sh at deploy time)
// before mounting React — ensures getConfig() is always safe to call synchronously.
loadConfig()
  .then(() => {
    const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement
    );
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <ThemeProvider>
            <OktaConfiguration>
              <App />
            </OktaConfiguration>
          </ThemeProvider>
        </BrowserRouter>
      </React.StrictMode>
    );
  })
  .catch((err) => {
    // eslint-disable-next-line no-console
    console.error('Failed to load runtime configuration:', err);
    const rootEl = document.getElementById('root');
    if (rootEl) {
      rootEl.innerHTML = '<div style="padding:2rem;font-family:sans-serif;color:#c00">Failed to load application configuration. Please try again or contact support.</div>';
    }
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
